import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import DataEntity from "../../../../../server/com/silkplm/engine/db/model/DataEntity.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.users.Organization';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class Organization extends DataEntity {

    /**
     *  @class Organization
     *  @alias module:src/server/com/silkplm/model/users/Organization.Organization
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.accountDeletionMessage = null;
        /** @type {string}  */
        this.alias = null;
        /** @type {string}  */
        this.bccEmailAddress = null;
        /** @type {Date}  */
        this.created = null;
        /** @type {boolean}  */
        this.deleted = null;
        /** @type {string}  */
        this.fullName = null;
        /** @type {string}  */
        this.id = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository}  */
        this.loginPageImage = null;
        /** @type {string}  */
        this.name = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository}  */
        this.navigationBarImage = null;
        /** @type {Date}  */
        this.removedTimestamp = null;
        /** @type {string}  */
        this.shortName = null;
        /** @type {string}  */
        this.subscriptionType = null;
        /** @type {number}  */
        this.subscriptionUserId = null;
        /** @type {string}  */
        this.template = null;
        /** @type {number}  */
        this.usersLimit = null;
        /** @type {number}  */
        this.version = null;

    }





    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withAccountDeletionMessage(val){
        this.accountDeletionMessage = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withAlias(val){
        this.alias = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withBccEmailAddress(val){
        this.bccEmailAddress = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withCreated(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.created = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withDeleted(val){
        this.deleted = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withFullName(val){
        this.fullName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withLoginPageImage(val){
        this.loginPageImage = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withName(val){
        this.name = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withNavigationBarImage(val){
        this.navigationBarImage = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withRemovedTimestamp(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.removedTimestamp = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withShortName(val){
        this.shortName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withSubscriptionType(val){
        this.subscriptionType = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withSubscriptionUserId(val){
        this.subscriptionUserId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withTemplate(val){
        this.template = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withUsersLimit(val){
        this.usersLimit = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/users/Organization.Organization}
     */
    withVersion(val){
        this.version = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['accountDeletionMessage'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['alias'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['bccEmailAddress'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['created'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['deleted'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['fullName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['loginPageImage'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['navigationBarImage'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository', 'mapped' : 'false'};
metadata['removedTimestamp'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['shortName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['subscriptionType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['subscriptionUserId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['template'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['usersLimit'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.users.Organization';
metadata.__type_short__ = 'Organization';
Organization.prototype.__metadata__ = metadata;

Organization.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/users/Organization */
export default Organization

export { Organization }
